import {
  constants,
  mediaQueryStyles,
  typographyStyles,
} from "@newsela/angelou";

const { mediaQuery } = mediaQueryStyles;
const {
  BreakpointNames: { md, sm },
} = constants.breakpoints;
const { heading4Obj, heading5Obj, textMObj } = typographyStyles;

const grey = constants.colors.ui.neutral[500];
const greyDark = constants.colors.ui.neutral[600];

export const containerCss = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  padding: "16px",
  margin: 0,
  textAlign: "left",
  minHeight: "min-content",
  overflowY: "auto",

  [mediaQuery.downTo(sm)]: {
    padding: "16px 40px",
  },

  [mediaQuery.downTo(md)]: {
    padding: "16px 24px",
  },
};

export const anchorCss = {
  marginTop: "24px",
  padding: 0,
};

export const detailsCss = [
  {
    margin: 0,
    color: grey,
    lineHeight: "24px",
    listStyleType: "none",
    padding: 0,
  },
  textMObj,
];

export const titleCss = [
  {
    margin: "16px 0",
    color: greyDark,
    fontWeight: "bold",
  },
  heading4Obj,
];

export const instructionsTextCss = {
  ...textMObj,
  margin: 0,
  lineHeight: "24px",
  color: greyDark,
};

export const instructionsHeaderCss = [
  {
    margin: "32px 0 16px",
    color: greyDark,
    fontWeight: "bold",
  },
  heading5Obj,
];
